import { environment } from "@/env/env.prod";
import { getCaptchaToken } from "./capcha.service";

export class FormUploadService {
    private readonly baseURL: string;

    constructor() {
        this.baseURL = environment.BASE_URL.replace(/\/$/, "");
    }

    // ───────────────── CONTACT FORM ─────────────────
    async uploadContactForm(formData: any): Promise<any> {
        console.log("FORMDATA CONTACT :::>", formData);

        const captchaToken = await getCaptchaToken();
        if (!captchaToken) {
            throw new Error("Captcha token not available");
        }

        const url = `${this.baseURL}/publicForm/endpoint/web/contactForm`;
        return this.post(url, formData, captchaToken);
    }

    // ───────────────── JOB FORM ─────────────────
    async uploadJobForm(formData: any): Promise<any> {
        console.log("FORMDATA JOB :::>", formData);

        const captchaToken = await getCaptchaToken();
        if (!captchaToken) {
            throw new Error("Captcha token not available");
        }

        const url = `${this.baseURL}/publicForm/endpoint/web/jobContactForm`;
        return this.post(url, formData, captchaToken);
    }

    // ───────────────── SHARED POST ─────────────────
    private async post(
        url: string,
        body: any,
        captchaToken: string
    ): Promise<any> {
        try {
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CAPTCHA-TOKEN": captchaToken   // 🔐 captcha header
                },
                body: JSON.stringify(body)
            });

            if (!res.ok) {
                const errText = await res.text();
                throw new Error(`HTTP ${res.status}: ${errText}`);
            }

            return await res.json();
        } catch (err) {
            console.error("Form upload failed:", err);
            throw err;
        }
    }
}
